import {
    UserActionType,
    UserActionsStatusResponse,
} from "../../../api/UserActionsStatus";
import { UserActionsStatusData } from "../logic/userActionsStatusSlice";


export const reviewerLevelDisplay: Record<UserActionType, string> = {
    [UserActionType.IR_L1_REVIEW]: "L1 Reviewer",
    [UserActionType.IR_L2_REVIEW]: "L2 Reviewer",
    [UserActionType.IR_L3_REVIEW]: "L3 Reviewer",
};

export const actionTypeToStateKey: Record<UserActionType, keyof UserActionsStatusData> = {
    [UserActionType.IR_L1_REVIEW]: "ir_l1_review",
    [UserActionType.IR_L2_REVIEW]: "ir_l2_review",
    [UserActionType.IR_L3_REVIEW]: "ir_l3_review",
};

/** API (lowercase) → UI (enum-based) */
export const mapApiToUi = (apiData: UserActionsStatusResponse | null): UserActionsStatusData => {
    if (!apiData) return {};

    return {
        ir_l1_review: apiData.ir_l1_review
            ? { action_type: UserActionType.IR_L1_REVIEW, review_status: apiData.ir_l1_review }
            : undefined,
        ir_l2_review: apiData.ir_l2_review
            ? { action_type: UserActionType.IR_L2_REVIEW, review_status: apiData.ir_l2_review }
            : undefined,
        ir_l3_review: apiData.ir_l3_review
            ? { action_type: UserActionType.IR_L3_REVIEW, review_status: apiData.ir_l3_review }
            : undefined,
    };
};
